import HeroSectionSection from '../components/HeroSection/HeroSection';
import FeaturesSection from '../components/HeroSection/FeaturesSection';
import CategoryShowcase from '../components/HeroSection/CategoryShowcase';
import FeaturedProducts from '../components/HeroSection/FeaturedProducts';
import CTASection from '../components/HeroSection/CTASection';
import SEO, { SITE_URL } from '../components/SEO';

const Home = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Tantika Crafts',
    url: SITE_URL,
    description:
      'Shop authentic handmade crafts, sarees, jewelry, home decor, pottery, and textiles from talented Indian artisans.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/shop?search={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <div>
      <SEO url="/" jsonLd={jsonLd} />
      <HeroSectionSection />
      <FeaturesSection />
      <CategoryShowcase />
      <FeaturedProducts />
      <CTASection />
    </div>
  );
};

export default Home;